import React from 'react';

/**
 * @typedef {object} SelectedPracticeInformationSelectedPracticeDataPracticeArea
 * @property {string} acronym
 */

/**
 * @typedef {object} SelectedPracticeInformationSelectedPracticeDataPractice
 * @property {number} groupLevel
 * @property {number} numberWithinLevel
 * @property {string} name
 */

/**
 * @typedef {object} SelectedPracticeInformationSelectedPracticeData
 * @property {SelectedPracticeInformationSelectedPracticeDataPracticeArea} [practiceArea]
 * @property {SelectedPracticeInformationSelectedPracticeDataPractice} [practice]
 */

/**
 * @typedef {object} SelectedPracticeInformationProps
 * @property {SelectedPracticeInformationSelectedPracticeData} [selectedPracticeData]
 */

/**
 * @param {SelectedPracticeInformationProps} props
 */
export const SelectedPracticeInformation = props => {
  const { selectedPracticeData } = props;
  if (!selectedPracticeData) {
    return 'Select a practice for more information.';
  }

  const { practiceArea, practice } = selectedPracticeData;

  return (
    <p className='no-margin'>
      <strong>
        {`${practiceArea.acronym} ${practice.groupLevel}.${practice.numberWithinLevel}: `}
      </strong>
      {practice.name}
    </p>
  );
};
